module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-LightItalic-4f712f17.ttf";